'use client'
import type { FC } from 'react'
import { GrandHeading, GrandSection, GrandText } from 'ui'
import { VStack } from '@chakra-ui/react'

interface IntegritietsPolicyComponentProps {}

const IntegritietsPolicyComponent: FC<IntegritietsPolicyComponentProps> = () => {
  return (
    <GrandSection contentContainerProps={{ spacing: 5 }} sectionId="policy">
      <VStack>
        <GrandHeading fontWeight="bold" headingTag="h1" px={1} title="INTEGRITETSPOLICY & GDPR" />
        <GrandText>
          I samband med nya förordningar som GDPR, har vi på Granditude anpassat vår hantering av
          personuppgifter så att de följer förordningens riktlinjer. Eftersom vi värnar om din
          integritet, vill vi dessutom vara helt transparenta om hur dina personuppgifter behandlas,
          samt informera dig om vilka rättigheter du har som besökare eller kund. I fallet att du
          lämnar ut dina personuppgifter, exempelvis vid registrering på vår hemsida, godkänner du
          att vi lagrar dina uppgifter enligt GDPR. Den godkända lagringen av personuppgifterna
          utförs för att vi ska kunna:
        </GrandText>
        <GrandText>Administrera beställningar</GrandText>
        <GrandText>Göra utskick av orderbekräftelser</GrandText>
        <GrandText>
          Fullföra rättsliga förpliktelser såsom ångerrätt och reklamation samt korrekt bokföring, i
          enlighet med BFL
        </GrandText>
        <GrandText>Utskick av nyhetsbrev, kampanjer och kunderbjudanden</GrandText>
      </VStack>

      <VStack>
        <GrandHeading
          fontWeight="bold"
          headingTag="h2"
          px={1}
          title="VILKA PERSONUPPGIFTER OM DIG BEHANDLAR VI?"
        />
        <GrandText>
          Alla uppgifter som lagras av oss, är i första hand sådana som du själv uppger i samband
          med en beställning. Exempelvis information om hemadress, e-post och mobiltelefonnummer. I
          enlighet med GDPR har du som kund alltid rätt till att få tillgång till all information.
          Vid förfrågan har du dessutom möjlighet till att korrigera, be om utlämning, eller radera
          all lagrad information.
        </GrandText>
      </VStack>

      <VStack>
        <GrandHeading fontWeight="bold" headingTag="h2" px={1} title="MILJÖPOLICY" />
        <GrandText>
          Miljötänk och hållbart arbete är en av Granditudes främsta kärnvärderingar. Genom att
          aktivt arbeta med frågor som exempelvis berör effektivisering av transporter och hållbara
          och energisnåla produkter, försöker vi ständigt minska vår miljöbelastning.
        </GrandText>
      </VStack>

      <VStack>
        <GrandHeading
          fontWeight="bold"
          headingTag="h2"
          px={1}
          title="UTLÄMNANDE TILL TREDJE PART"
        />
        <GrandText>
          Vi säljer, handlar, eller på annat sätt överför, inte personligt identifierbar information
          till utomstående parter. Detta inkluderar inte betrodd tredjepart som hjälper oss att
          driva vår webbplats eller vårt företag, med kravet att dessa parter godkänner att hålla
          informationen konfidentiell.
        </GrandText>
      </VStack>

      <VStack>
        <GrandHeading fontWeight="bold" headingTag="h2" px={1} title="COOKIES" />
        <GrandText>
          Vi på Granditude använder Cookies på vår webbplats. Cookies är små textfiler som används
          för att lagra information i användarens webbläsare, oavsett om du surfar på dator, mobil
          eller surfplatta. Vi använder cookies för att optimera upplevelsen hos våra kunder och för
          att hemsidans alla funktioner ska fungera rent tekniskt. Exempelvis hjälper de oss att
          hålla koll på vilka varor du har, eller tidigare har haft i din varukorg – för att
          underlätta vid framtida besök. Dessutom underlättar de processen med att ta fram förslag
          och filtrera ut möjliga produkter du kan tänkas uppskatta. Cookies-funktionen tillåter oss
          också att övervaka webbplatsens trafik samt som verktyg för att föra statistik, vilket vi
          använder för att löpande utveckla och förbättra det innehåll vi presenterar
        </GrandText>
        <GrandText>Två olika typer av cookies:</GrandText>
        <GrandText>
          Sessioncookie är en cookie som lagras på din enhet tillfälligt, medan du surfar -
          försvinner när du avslutar den pågående sessionen.
        </GrandText>
        <GrandText>
          Permanent cookie är en cookie som lagras i din webbläsare tills att du tar bort den.
        </GrandText>
      </VStack>

      <VStack>
        <GrandHeading
          fontWeight="bold"
          headingTag="h2"
          px={1}
          title="COOKIE-FUNKTIONEN ÄR FRIVILLIG"
        />
        <GrandText>
          Cookies-funktionen är självklart frivillig för dig som besökare och något som du kan avstå
          från genom att avböja förfrågan som skickas ut vid ditt första besök på hemsidan. Är det
          så att du råkat acceptera eller avböja förfrågan, och vill rensa eller återaktivera
          lagringen av information gör du det genom följande steg:
        </GrandText>
        <GrandText>Öppna din webbläsare</GrandText>
        <GrandText>
          Klicka på mer eller välj de lodräta prickarna uppe i webbläsarens högra hörn och välj
          inställningar/avancerade inställningar
        </GrandText>
        <GrandText>
          Klicka sedan på sekretess och säkerhet , välj webbplatsinställningar och tryck sedan på
          cookies
        </GrandText>
        <GrandText>
          Aktivera eller inaktivera sedan tillåt att webbplatser sparar och läser cookiedata
        </GrandText>
        <GrandText>
          Observera att du på denna sida även kan styra över din allmänna cookie-hantering,
          exempelvis radera den befintliga data som lagrats sedan tidigare
        </GrandText>
      </VStack>
    </GrandSection>
  )
}

export default IntegritietsPolicyComponent
